<template>
    <div class="v-setting-dropdown">

        <div class="v-setting-dropdown__label">
            {{ label }}

            <template v-if="loading">
                <div class="v-setting-dropdown__loader">
                    <v-ellipsis-loader/>
                </div>
            </template>

            <template v-if="failed">
                <div class="v-setting-dropdown__failed">
                    {{ $t('settingDropdown.failed ', {adminName: admin.name})}}
                </div>
            </template>
        </div>

        <div class="v-setting-dropdown__dropdown" v-if="!disabled">
            <select class="v-setting-dropdown__select" v-model="val" @change="emit">
                <template v-for="option in options">
                    <option :value="option.value" v-bind:key="option.value">{{option.label}}</option>
                </template>
            </select>
        </div>

        <div class="v-setting-dropdown__value" v-if="disabled">
            {{ currentOption.label }}
        </div>

    </div>

</template>

<script>

  import vEllipsisLoader from "./vEllipsisLoader"
  import PORTAL from "../config/portals/config"

  export default {
    name: "SettingDropdown",
    components: {
      vEllipsisLoader
    },
    data() {
      return {
        val: this.value
      }
    },
    props: {
      value: { type: String, default: "" },
      options: { type: Array, required: true },
      disabled: { type: Boolean, default: false },
      loading: { type: Boolean, default: false },
      failed: { type: Boolean, default: false },
      label: { type: String, default: "" }
    },
    computed: {
      currentOption() {
        return this.options.find(opt => opt.value === this.value);
      },
      admin(){
        return PORTAL.admin
      }

    },
    methods: {
      emit($event) {
        this.$emit('input', $event.target.value)
      }
    },
    watch: {
      value() {
        this.val = this.value;
      }
    }

  }
</script>

<style lang="scss">
    .v-setting-dropdown {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: .75em 0;

        &__loader {
            font-size: .5em;
        }

        &__failed {
            padding: .3em 0;
            color: peachpuff;
            font-size: .9em;

        }

        &__label {
            font-weight: 600;
            font-size: .85em;
        }

        &__select {
            font-size: .85em;
            width: auto;
            background-color: #f7f7f7;
            border: 0;
            border-radius: 5em;
            padding: .5em 1em;
            text-align: right;
            outline: none;
        }
    }


</style>